import { Directive, HostBinding, input, computed } from '@angular/core';
import { ResponsiveSize } from '../types/responsive-size.type';

export type { ResponsiveSize } from '../types/responsive-size.type';

@Directive({
  selector: '[responsiveSize]',
  standalone: true,
})
export class ResponsiveSizeDirective {
  readonly responsiveSize = input<ResponsiveSize>('16px');

  private readonly parsedSize = computed(() => {
    const size = this.responsiveSize();
    if (typeof size === 'object') {
      return {
        mobile: size.mobile ?? '16px',
        tablet: size.tablet,
        desktop: size.desktop,
      };
    }
    return {
      mobile: size,
      tablet: undefined,
      desktop: undefined,
    };
  });

  @HostBinding('style.--size-mobile')
  get cssVarSizeMobile(): string {
    return this.normalizeSize(this.parsedSize().mobile);
  }

  @HostBinding('style.--size-tablet')
  get cssVarSizeTablet(): string | null {
    const tabletSize = this.parsedSize().tablet;
    return tabletSize !== undefined ? this.normalizeSize(tabletSize) : null;
  }

  @HostBinding('style.--size-desktop')
  get cssVarSizeDesktop(): string | null {
    const desktopSize = this.parsedSize().desktop;
    return desktopSize !== undefined ? this.normalizeSize(desktopSize) : null;
  }

  private normalizeSize(size: string | number): string {
    return typeof size === 'number' ? `${size}px` : size;
  }
}
